import * as THREE from "three";
import eventListenerOption from '../../lib/eventListenerOption';

export default class RenderingTracker {
	private isRenderingValue = false;
	private updateScene = false;

	private renderer: THREE.WebGLRenderer;
	private updateAndRender: THREE.XRAnimationLoopCallback;

	constructor(renderer: THREE.WebGLRenderer, updateAndRender: THREE.XRAnimationLoopCallback, win: Window) {
		this.renderer = renderer;
		this.updateAndRender = updateAndRender;

		let onResizeDebouncerTimeout: number;
		win.addEventListener("resize", (event: UIEvent) => {
			clearTimeout(onResizeDebouncerTimeout);
			//@ts-ignore
			onResizeDebouncerTimeout = setTimeout(
				() => { this.updateScene = true; },
				200
			);
		}, eventListenerOption.passiveNotCapture);

		/* Removed becauses issues and not recreating should be fine.
		win.addEventListener("touchend", () => {
			this.updateScene = true;
		}, eventListenerOption.passiveNotCapture); // This is because the address bar on mobile devices can hide when scrolled.
		*/
		
		win.document.addEventListener("visibilitychange", (event: Event) => {
			if (win.document.visibilityState === "hidden") {
				this.pauseRendering();
			} else if (this.isRenderingValue !== true) {
				this.startRendering();
			}
		}, eventListenerOption.passiveNotCapture);

		/*
		win.addEventListener("pageshow", (event: PageTransitionEvent) => {
			alert("Page show: " + event.persisted);
		});
		*/

		this.renderer.setAnimationLoop(this.updateAndRender);
	}

	public isUpdateNeeded(): boolean {
		return this.updateScene;
	}
	public setUpdateNeeded(isUpdateNeeded: boolean) {
		return this.updateScene = isUpdateNeeded;
	}

	public isRendering(): boolean {
		return this.isRenderingValue;
	}

	public startRendering() {
		this.isRenderingValue = true;
		this.updateScene = true;
	}
	public pauseRendering() {
		this.isRenderingValue = false;
	}
}